import { createEventTracker } from '../util';
import { ElementArchiveAnalytics } from './types';

export const trackElementArchived = createEventTracker<ElementArchiveAnalytics>('Element Archived');
